export default __webpack_public_path__ + "img/dPpTjvUn.ef02bdcf.svg";